import parse from "html-react-parser";
import {useEffect, useRef} from "react";

export default function DynamicTextAreaField({field, value, onFieldChange, error}) {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // reset
            textareaRef.current.style.height =
                textareaRef.current.scrollHeight + "px";
        }
    }, [value]);

    return <div>
        <label className="block text-x font-medium mb-1" htmlFor={field.code}>
            {field.name} {field.required && (<span className="text-red-600">*</span>)}
        </label>
        {field.help && (
            <div className="text-sm text-gray-500 mt-1 mb-2">
                {parse(field.help)}
            </div>
        )}
        <textarea
            onChange={onFieldChange}
            ref={textareaRef}
            value={value || ""}
            rows={3} // minimum visible rows
            className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2
            ${error
                ? "border-red-500 focus:ring-red-400"
                : "border-gray-300 focus:ring-[#2f855a]"
            }`}
            id={field.code}/>

        {error && (
            <div className="text-red-600 text-sm mt-1">
                {error}
            </div>
        )}

    </div>

}